import { useState, useEffect } from "react";
import { Card, Title, Label, Input, Overlay, ModalCloseButton } from "../CommonComponents/DataCard";
import Spinner from "../CommonComponents/Spinner";
import { getIllustratorById, updateIllustrator } from "../../services/IllustratorService";
import Button from "../CommonComponents/Button";
import { getCurrentUser } from "../../services/AuthService";
import { ROLES } from "../../services/Constants";
import MessageModal from "../CommonComponents/MessageModal";

function EditIllustratorModal({ isOpen, onClose, id, onIllustratorUpdated }) {
    const [Illustrator, setIllustrator] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState("");
    const [currentUser, setCurrentUser] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageSuccess, setMessageSuccess] = useState(false);
    const [showMessageModal, setShowMessageModal] = useState(false);

    useEffect(() => {
        if (!isOpen || !id) return;

        const fetchData = async () => {
            setLoading(true);
            setError("");
            try {
                const userData = await getCurrentUser();
                if (userData.authenticated === true) {
                    setCurrentUser(userData);
                } else {
                    setCurrentUser(null);
                }
            } catch {
                setCurrentUser(null);
            }
            try {
                const IllustratorData = await getIllustratorById(id);
                setIllustrator(IllustratorData);
            } catch (err) {
                setError(err.message || "Greška prilikom učitavanja ilustratora");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [isOpen, id]);

    if (!isOpen) return null;
    if (!currentUser || !(currentUser.role === ROLES.EMPLOYEE || currentUser.role === ROLES.ADMIN)) {
        return null;
    }

    const handleChange = (e) => {
        setIllustrator({ ...Illustrator, [e.target.name]: e.target.value });
    };

    const handleSave = async () => {
        setSaving(true);
        setError("");
        try {
            const updated = await updateIllustrator(id, Illustrator);

            setMessage("Ilustrator je uspješno ažuriran!");
            setMessageSuccess(true);
            setShowMessageModal(true);

            // Call callback and close after showing success message
            setTimeout(() => {
                if (onIllustratorUpdated) onIllustratorUpdated(updated);
                onClose();
            }, 1500);
        } catch (err) {
            setMessage(err.message || "Greška pri spremanju ilustratora.");
            setMessageSuccess(false);
            setShowMessageModal(true);
        } finally {
            setSaving(false);
        }
    };

    const handleCloseModal = () => {
        setShowMessageModal(false);
    };

    return (
        <Overlay onClick={onClose} style={{ alignItems: "flex-start", padding: "2rem 1rem", overflowY: "auto", boxSizing: "border-box" }}>
            <div onClick={e => e.stopPropagation()} style={{ width: "fit-content" }}>
                <Card style={{ position: "relative" }}>
                <ModalCloseButton onClick={onClose} title="Zatvori" style={{ position: "absolute", top: "0.75rem", right: "0.75rem" }}>×</ModalCloseButton>
                    <MessageModal
                        isOpen={showMessageModal}
                        onClose={handleCloseModal}
                        title="Uređivanje ilustratora"
                        variant={messageSuccess ? "success" : "error"}
                    >
                        {message}
                    </MessageModal>

                    {loading ? (
                        <Spinner />
                    ) : error ? (
                        <div style={{ color: "red" }}>{error}</div>
                    ) : (
                        <>
                            <Title>Uredi ilustratora: {Illustrator.name} {Illustrator.surname}</Title>

                            <Label>Ime:</Label>
                            <Input name="name" value={Illustrator.name} onChange={handleChange} />

                            <Label>Prezime:</Label>
                            <Input name="surname" value={Illustrator.surname} onChange={handleChange} />

                            <div style={{ display: "flex", gap: "8px", marginTop: "16px", justifyContent: "flex-end" }}>
                                <Button tekst="Odustani" akcija={onClose} />
                                <Button tekst={saving ? "Spremanje..." : "Spremi"} akcija={handleSave} />
                            </div>
                        </>
                    )}
                </Card>
            </div>
        </Overlay>
    );
}

export default EditIllustratorModal;
